define('views/map/name_infowindow',[
    'backbone',
    'text!views/map/name_infowindow.html',
    'views/_base/baseview'
], function(Backbone, Template, BaseView){
    'use strict';

    // We do not need a global variable but we need a variable outside of the initialize closure to be referenced within the Google Map Overlay functions
    var that = null,
        data = null;

    return BaseView.extend({
        template   : _.template(Template),
        tagName    : 'div',
        className  : 'map-name-infowindow-container',
        isRender   : false,
        needsAuth  : false,
        scrollToTop: false,
        events     : {},
        initialize : function(options) {
            that = this;
            
            data = options;

            // Extend google.maps.OverlayView()
            that.infowindow = new google.maps.OverlayView();

            // Now initialize all properties
            that.content = null;
            that.map = options.map;

            // Add the Merchant config to update later
            that.merchant = null;

            // Will hold infowindow content
            that.container = null;

            // Explicitly call setMap on this overlay
            that.infowindow.setMap(that.map);

            // onAdd is called when the map is ready for the infowindow to be attached
            that.infowindow.onAdd = this.onAdd;
            // Draw is called every time we show the infowindow
            that.infowindow.draw = this.draw;
            // onRemove, not used at the moment but would be used to completely remove the infowindow
            that.infowindow.onRemove = this.onRemove;
            // Show and Hide the infowindow
            that.infowindow.hide = this.hide;
            that.infowindow.show = this.show;
            BaseView.prototype.initialize(this);
        },

        render: function() {
            this.$el.html(this.template({ data: data }));
            return this;
        },

        setData: function(new_data){
            data = new_data;
        },

        onAdd: function(){
            // Create the infowindow container
            var contentContainer = document.createElement('DIV');
            // Insert content if there is any and add class
            contentContainer.innerHTML = that.content;
            contentContainer.className = 'map-name-infowindow-container';
            // Set the overlay's container property to this DIV
            that.container = contentContainer;
            // We add the infowindow to the map via one the map's floating panes
            var panes = that.infowindow.getPanes();
            panes.floatPane.appendChild(that.container);
        },

        draw: function() {
            // Get the projected overlay position in conjunction with the current merchant marker
            var overlayProjection = that.infowindow.getProjection();
            
            if(overlayProjection && that.marker){
                // Get the coordinates of the marker in latlngs and convert them to pixels coordinates to position the infowindow
                var ne = overlayProjection.fromLatLngToDivPixel(that.marker.getPosition());
                // Add content and position the infowindow
                // var arrow = '<div class="map-info-window-arrow"><div class="map-info-window-arrow-left"><div class="map-info-window-arrow-left-inner"></div></div><div class="map-info-window-arrow-right"><div class="map-info-window-arrow-right-inner"></div></div></div>';
                var content = that.container;
                // content.innerHTML = that.content+arrow;
                content.innerHTML = that.content;
                content.style.left = (ne.x - 100) + 'px';
                content.style.top = (ne.y + 4) + 'px';
            }
        },

        setContent: function(content){
            that.content = content;
        },

        getMap: function(){
            return that.infowindow.getMap();
        },

        show: function(marker, markerEvent, model){
            
            // If the previous marker and merchant exist
            if(that.marker && that.merchant){
                var previous_marker_icon = that.getMarkerIcon(that.merchant),
                    current_marker_icon = that.getMarkerIcon(model, true);

                // Update previous marker icon to inactive icon
                that.marker.setIcon(previous_marker_icon);

                // Update current marker icon to active icon
                marker.setIcon(current_marker_icon);
            } else if(model){
                var current_marker_icon = that.getMarkerIcon(model, true);

                // If first marker, then set the icon to use an active icon
                marker.setIcon(current_marker_icon);
            }

            that.merchant = model;
            that.marker = marker;

            if(that.marker && that.map){
                
                if(that.container){
                    that.container.style.visibility = 'visible';
                    that.marker = marker;
                    that.infowindow.draw();
                }
                // Only pan if marker is out of view
                var is_within_view = that.map.getBounds().contains(that.marker.getPosition());

                if(!markerEvent && !is_within_view){
                    var markerPosition = marker.getPosition();
                    that.map.panTo(markerPosition);
                }
            }
        },

        hide: function() {
            if(that.container){
                that.container.style.visibility = 'hidden';
            }
        },

        close: function(){
            that.infowindow.hide();
        },

        onRemove: function() {
            $(that.container).remove();
            that.container.parentNode.removeChild(that.container);
        },

        getMarkerIcon: function(merchant, active){
            var active = (active) ? '-active' : '',
                agid = (merchant.attributes) ? merchant.attributes.AggregatorID : merchant.AggregatorID;

            if(agid == enums.aggregatorID.Blackhawk){
                return 'img/maps/scan' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Empyr){
                return 'img/maps/swipe' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Print){
                return 'img/maps/print' + active + '-map-icon.png';
            } else if(agid == enums.aggregatorID.Priceline){
                return 'img/maps/book' + active + '-map-icon.png';
            } else {
                // return 'img/maps/location_pin.png';
                return 'img/maps/swipe' + active + '-map-icon.png';
            }

        }
    });
});
